import { formatToDDMMYYYY } from "@/services/utils";

export function formatDateToDDMMYYYY (value) {
    if (!value) return value;
    return formatToDDMMYYYY(value);
}